﻿(function ()
{
    if (document.querySelector('.popular-categories-carousel'))
    {
        var slider = tns({
            container: '.popular-categories-carousel',
            loop: false,
            controls: true,
            autoplay: false,
            nav: false,
            gutter: 10,
            mouseDrag: true,
            fixedWidth: 250,
            swipeAngle: false,
            slideBy: "page",
            lazyload: true,
            useLocalStorage: false,
            speed: 400,
            controlsContainer: ".popular-categories-controls",
            responsive: {
                768: {
                    fixedWidth: 270,

                }
            },
            onInit: function ()
            {
                document.getElementsByClassName("popular-categories-carousel")[0].classList.add("init");
            },

        });
    }
})();

